// extracted by mini-css-extract-plugin
module.exports = {"itemLabel":"item-checkbox_itemLabel__X2yFw","labelSelected":"item-checkbox_labelSelected__X10RT","fade-in":"item-checkbox_fade-in__4D61v"};